module.exports = __webpack_public_path__ + "static/media/payment-bg.59282588.png";